import { memo } from 'react';
import { GetOutFamilyTemplate } from 'components/templates/GetOutFamilyTemplate';

type Props = {};

export const GetOutFamily = memo((_props: Props) => {
	return <GetOutFamilyTemplate />;
});
